<template>
  <app-layout>
    <stack-list v-if="scripts.length" class="w-full">
      <stack-list-item v-for="(script, idx) in scripts"  :key="`script${idx}-${script.id || ''}`" ref="script">
        <template v-slot:default>
          <div class="flex gap-4">
            <div v-if="script.id"  class="flex-none flex space-x-3">
              <button @click.stop="shift(script.id, 'up')" :class="script.sort_order <= 0 ? 'opacity-25 pointer-events-none' : ''">
                <arrow-up-icon class="h-3 w-3 'text-gray-300 hover:text-gray-400'" />
              </button>
              <button @click.stop="shift(script.id, 'down')" :class="script.sort_order >= scripts.length - 1 ? 'opacity-25 pointer-events-none' : '' ">
                <arrow-down-icon class="h-3 w-3 'text-gray-300 hover:text-gray-400'" />
              </button>
            </div>
            <p>{{ script.name ? `${script.name} (${script.position})` : 'New Script' }}</p>
          </div>
        </template>
        <template v-slot:expand>
          <base-input label="Name" v-model="script.name" class="mb-4" />
          <base-input label="Type" v-if="!script.id" class="mb-4">
            <el-select v-model="script.type">
              <option value="necessary">Necessary</option>
              <option value="functionality">Functionality</option>
              <option value="analytics">Analytics</option>
              <option value="advertisement">Advertisement</option>
              <option value="security">Security</option>
            </el-select>
          </base-input>
          <base-input label="Position" v-if="!script.id" class="mb-4">
            <el-select v-model="script.position">
              <option value="head">Head Tag</option>
              <option value="body-top">Body (Top)</option>
              <option value="body-bottom">Body (Bottom)</option>
            </el-select>
          </base-input>
          <base-input label="Src" v-model="script.src" class="mb-4"></base-input>
          <base-input label="Code" class="mb-4">
            <base-text-area v-model="script.code" rows="10"  />
            <p><small class="form-text text-muted">Please do not include the <span class="font-mono">&lang;script&rang;&lang;/script&rang;</span> part of the code.</small></p>
          </base-input>
          <base-input label="Additional Attributes" v-model="script.attrs" class="mb-4"></base-input>
          <base-button @click="save(script)" class="mr-4">{{ `${ script.id ? 'Save' : 'Create' }` }}</base-button>
          <base-button v-if="script.id" @click="del(script)" type="danger">Delete</base-button>
        </template>
      </stack-list-item>
    </stack-list>
    <base-card v-else>
      <p>No scripts added. Click add to start using the scripts manager.</p>
    </base-card>
    <div class="mt-4">
      <base-button @click="add">Add</base-button>
    </div>
  </app-layout>
</template>
<script>
import Form from '../components/Form'
import Stack from '../components/Stack'
import Table from '../components/Table'
import Actions from '../components/Actions'
import { PencilAltIcon, TrashIcon, CheckCircleIcon, XCircleIcon, RefreshIcon, ArrowUpIcon, ArrowDownIcon } from '@vue-hero-icons/solid'

export default {
  name: 'scripts',
  components: {
    ...Stack,
    ...Form,
    ...Table,
    ...Actions,
    PencilAltIcon,
    TrashIcon,
    CheckCircleIcon,
    XCircleIcon,
    ArrowDownIcon,
    ArrowUpIcon,
    RefreshIcon
  },
  data() {
    return {

    }
  },
  mounted() {
    window.addEventListener('listingReload', this.listingReload);
  },
  props: {
    scripts: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    add() {
      if (!this.scripts.filter(s => !s.id).length) {
        this.scripts.push({
          name: '',
          type: 'necessary',
          position: 'head',
          src: '',
          code: '',
          attrs: '',
          sort_order: this.scripts.length
        });
        this.$nextTick(() => {
          this.$refs.script[this.$refs.script.length-1].$el.firstChild.dispatchEvent(new MouseEvent('click'));
        })
      }
    },
    shift(id, direction) {
      this.$inertia.put(
        route(`cms.scripts.shift`, {
          id: id,
        }),
        {
          direction,
        },
        {
          preserveState: true,
          preserveScroll: true,
          only: ['items'],
          onBefore: () => document.body.classList.add('is-waiting'),
          onFinish: () =>
            this.$nextTick(() => {
              window.dispatchEvent(new CustomEvent('listingReload'))
            }),
        }
      );
    },
    save(script) {
      if(script.id) {
        this.$CMS_UPDATE('scripts', script.id, script);
      } else {
        this.$CMS_CREATE('scripts', {}, script).then((data)=>{
          if(data.script.id) {
            const idx = this.scripts.findIndex((s) => {
              return s.name === data.script.name;
            });
            this.scripts[idx].id = data.script.id;
            this.$refs.script[this.$refs.script.length-1].$el.firstChild.dispatchEvent(new MouseEvent('click'));
          }
        });
      }
    },
    del(script) {
      this.$inertia.delete(route(`cms.scripts.destroy`, { id: script.id }), {
        preserveState: true,
        preserveScroll: true,
        only: ['scripts'],
        onBefore: () => confirm('Are you sure you want to delete this item?'),
        onStart: () => document.body.style.cursor = 'wait',
        onFinish: () => document.body.style.cursor = 'default'
      })
    },
    listingReload() {
      this.$inertia.reload();
      document.body.classList.remove('is-waiting');
    }
  }
}
</script>
